import TableTemplate from "../TableTemplate/tableTemplate";
import { getIVRefTable } from "../../Requests/marketmaking";
import { CommonTableUI } from "../TableTemplate/common";

const IVRefTable = () => {
  return (
    <TableTemplate<{}, any>
      refreshTableTime={5000}
      getDataTable={getIVRefTable}
      withSort
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[200px]"
        />
      )}
    />
  );
};

export default IVRefTable;
